import { clsx } from "clsx";

const defaultStyles =
  "group flex items-center gap-2 rounded border-neutral-200 border-solid border-[1px] text-neutral-850 bg-neutral-20 px-[1rem]";

const hoverStyles = "hover:bg-white";
const disabledStyles =
  "bg-neutral-50 text-neutral-400 cursor-not-allowed border-neutral-50";
const errorStyles = "border-red-550 shadow-error";
const focusStyles =
  "focus-within:shadow-[0px_0px_0px_4px_rgba(174,211,254,0.6)] focus-within:border-blue-560";
const highlightedStyles =
  "shadow-[0px_0px_0px_4px_rgba(174,211,254,0.6)] border-blue-560";

const inputStyles =
  "border-0 outline-none w-full h-10 font-inter text-mobile mobile:text-ui bg-neutral-20 group-hover:enabled:bg-white";
const inputDisabledStyles =
  "disabled:bg-neutral-50 disabled:text-neutral-400 disabled:cursor-not-allowed";

export const getWrapperClassNames = ({
  error,
  disabled,
  compact,
  highlighted,
}: {
  error?: boolean;
  disabled?: boolean;
  compact?: boolean;
  highlighted?: boolean;
}) =>
  clsx(
    defaultStyles,
    compact ? "py-[0.25rem]" : "py-[0.65rem]",
    !disabled && hoverStyles,
    !error && focusStyles,
    !error && highlighted && highlightedStyles,
    disabled && disabledStyles,
    error && errorStyles,
    "rounded-[var(--input-brand-radius,0.8rem)]",
  );

export const inputClassNames = clsx(inputStyles, inputDisabledStyles);

export type MaxInputHeight =
  | "xSmall"
  | "small"
  | "medium"
  | "large"
  | "xLarge"
  | "full";

export const maxInputHeightClassNames: Record<MaxInputHeight, string> = {
  xSmall: "max-h-[2.5rem] overflow-y-auto",
  small: "max-h-[5.5rem] overflow-y-auto",
  medium: "max-h-[9rem] overflow-y-auto",
  large: "max-h-[12rem] overflow-y-auto",
  xLarge: "max-h-[15rem] overflow-y-auto",
  full: "max-h-full",
};
